export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'kepungkur',
    suffixFromNow: 'seko saiki',
    seconds: 'kurang seko sakmenit',
    minute: 'kurang luwih sakmenit',
    minutes: '%d menit',
    hour: 'kurang luwih sakjam',
    hours: 'kurang luwih %d jam',
    day: 'sedina',
    days: '%d dina',
    month: 'kurang luwih sewulan',
    months: '%d wulan',
    year: 'kurang luwih setahun',
    years: '%d tahun',
};
